import jwtDecode from 'jwt-decode';
import { createReducer } from '../utils/helpers';
import constants from '../constants';

const { LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER } = constants;

const initialState = {
  token: null,
  userId: null,
  nation: null,
  isAdmin: false,
  isFederation: false,
  isLoggedIn: false,
  isAuthenticating: false,
};

export default createReducer(initialState, {
  [LOGIN_USER_REQUEST]: state => ({
    ...state,
    ...{
      isAuthenticating: true,
    },
  }),
  [LOGIN_USER_SUCCESS]: (state, payload) => {
    const { token } = payload;

    const decoded = jwtDecode(token);

    const { userId, nation, isAdmin, isFederation } = decoded;

    return {
      ...state,
      ...{
        token,
        userId,
        nation,
        isAdmin,
        isFederation,
        isLoggedIn: true,
        isAuthenticating: false,
      },
    };
  },
  [LOGIN_USER_FAILURE]: state => ({
    ...state,
    ...{
      token: null,
      userId: null,
      nation: null,
      isAdmin: false,
      isFederation: false,
      isLoggedIn: false,
      isAuthenticating: false,
    },
  }),
  [LOGOUT_USER]: state => ({
    ...state,
    ...{
      token: null,
      userId: null,
      nation: null,
      isAdmin: false,
      isFederation: false,
      isLoggedIn: false,
    },
  }),
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js